/**
 * gets input type based on format from data
 * @param  {string} format
 * @return {string}
 */
export const getInputType = (format) => {
  switch (format) {
    case '0%':
      return 'percentage';
    case '0,0':
      return 'decimal';
    case '$0.00':
      return 'dollar';
    default:
      return '';
  }
};
